<div
  class="ui-icon-tab-bar"
  [class.ui-icon-tab-bar--icons]="appearance() === 'icons'"
  role="tablist"
>
  @for (tab of tabs(); track tab.id) {
    <button
      type="button"
      role="tab"
      class="ui-icon-tab-bar__tab"
      [class.ui-icon-tab-bar__tab--active]="isActive(tab.id)"
      [attr.aria-selected]="isActive(tab.id)"
      [attr.aria-label]="tab.label"
      [attr.title]="appearance() === 'icons' ? tab.label : null"
      (click)="select(tab.id)"
    >
      @if (tab.iconSrc) {
        <span
          class="ui-icon-tab-bar__icon"
          [style.mask-image]="iconMask(tab.iconSrc)"
          [style.webkitMaskImage]="iconMask(tab.iconSrc)"
          aria-hidden="true"
        ></span>
      }
      @if (appearance() !== 'icons') {
        <span class="ui-icon-tab-bar__label">{{ tab.label }}</span>
      }
    </button>
  }
</div>
